import { useTranslation } from 'react-i18next';
import useSrm from '@/shared/data/useSrm';

const SrmDetailsCard = ({ withDescription = true }: { withDescription?: boolean }) => {
  const srm = useSrm();
  const { t } = useTranslation();

  return (
    <div className="rounded-xl border-[0.5px] border-stroke p-6">
      <div className="flex flex-wrap items-center gap-4">
        {srm?.image ? (
          <div className="flex size-20 shrink-0 items-center justify-center self-center overflow-hidden rounded-full bg-blue-500">
            <img alt={srm?.emailAddress ?? srm.image} src={srm.image} className="ml-2" />
          </div>
        ) : null}
        <div className="flex flex-col">
          {srm?.name ? <p className="pb-0.5 text-xl font-bold">{srm.name}</p> : null}
          {srm?.emailAddress ? (
            <a href={`mailto:${srm.emailAddress}`} className="text-sm font-bold text-blue-500">
              {srm.emailAddress}
            </a>
          ) : null}
          {/* Some srm have two phone numbers split with a / */}
          {srm?.phoneNumber
            ? srm.phoneNumber.split('/').map((phoneNumber) => (
                <div key={phoneNumber}>
                  <a href={`tel:${phoneNumber}`} className="text-sm font-bold text-blue-500">
                    {phoneNumber}
                  </a>
                </div>
              ))
            : null}
          {srm?.calendarLink ? (
            <div>
              <a href={srm.calendarLink} rel="noreferrer" target="_blank" className="text-sm font-bold text-blue-500">
                {t('helpSection.srm.scheduleConversation')}
              </a>
            </div>
          ) : null}
        </div>
      </div>
      {withDescription && (
        <div className="mt-2 text-sm text-text-secondary">{t('helpSection.srm.contactTrustedAdvisor')}</div>
      )}
    </div>
  );
};

export default SrmDetailsCard;
